"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var State = /** @class */ (function () {
    function State() {
        var _this = this;
        this.fileUploads = {
            add: function (fileUpload) {
                _this._fileUploads.push(fileUpload);
            },
            getById: function (id) {
                return _this._fileUploads.find(function (fileUpload) { return fileUpload.id === id; });
            },
            getByFileId: function (fileId) {
                return _this._fileUploads.find(function (fileUpload) { return fileUpload.fileId === fileId; });
            },
            remove: function (fileId) {
                _this._fileUploads = _this._fileUploads.filter(function (fileUpload) { return fileUpload.fileId !== fileId; });
            },
            incrementChunksDoneCount: function (fileId) {
                _this._fileUploads.map(function (fileUpload) {
                    if (fileUpload.fileId === fileId) {
                        fileUpload.incrementChunksDoneCount();
                    }
                    return fileUpload;
                });
            },
            decrementChunksDoneCount: function (fileId) {
                _this._fileUploads.map(function (fileUpload) {
                    if (fileUpload.fileId === fileId) {
                        fileUpload.decrementChunksDoneCount();
                    }
                    return fileUpload;
                });
            },
            setFileHash: function (fileId, fileHash) {
                _this._fileUploads.map(function (fileUpload) {
                    if (fileUpload.fileId === fileId) {
                        fileUpload.fileHash = fileHash;
                    }
                    return fileUpload;
                });
            },
            setFileId: function (id, fileId) {
                _this._fileUploads.map(function (fileUpload) {
                    if (fileUpload.id === id) {
                        fileUpload.fileId = fileId;
                    }
                    return fileUpload;
                });
            },
            getAll: function () { return _this._fileUploads; },
            setIsChunked: function (id) {
                _this._fileUploads.map(function (fileUpload) {
                    if (fileUpload.id === id) {
                        fileUpload.isChunked = true;
                    }
                });
            }
        };
        this.uploaders = {
            add: function (uploader) {
                _this._uploaders = _this._uploaders.concat(uploader);
            },
            getAll: function () { return _this._uploaders; }
        };
        this.uploadJobs = {
            add: function (uploadJob) {
                _this._uploadJobs.push(uploadJob);
            },
            get: function (id) {
                return _this._uploadJobs.find(function (uploadJob) { return uploadJob.chunk.id === id; });
            },
            getByFileId: function (fileId) {
                return _this._uploadJobs.filter(function (job) { return job.chunk.fileId === fileId; });
            },
            removeByFileId: function (fileId) {
                return (_this._uploadJobs = _this._uploadJobs.filter(function (job) { return job.chunk.fileId !== fileId; }));
            },
            removeByChunkId: function (chunkId) {
                var filteredJobs = _this._uploadJobs.filter(function (job) { return job.chunk.id !== chunkId; });
                _this._uploadJobs = filteredJobs;
                return filteredJobs;
            },
            getAll: function () { return _this._uploadJobs; },
            setAll: function (uploadJobs) {
                _this._uploadJobs = uploadJobs;
            },
            addRequestSource: function (chunkId, requestSource) {
                _this._uploadJobs = _this._uploadJobs.map(function (job) {
                    if (job.chunk.id === chunkId) {
                        job.requestSource = requestSource;
                    }
                    return job;
                });
            },
            // TODO: Remove addUploadRequest
            addUploadRequest: function (id, uploadRequest) {
                _this._uploadJobs = _this._uploadJobs.map(function (job) {
                    if (job.chunk.id === id) {
                        job.uploadRequest = uploadRequest;
                    }
                    return job;
                });
            },
            chunks: {
                updateChunkProgress: function (id, chunkProgress) {
                    _this._uploadJobs = _this._uploadJobs.map(function (job) {
                        if (job.chunk.id === id) {
                            job.chunk.progress = chunkProgress;
                        }
                        return job;
                    });
                },
                remove: function (chunkId, jobs) {
                    if (jobs === void 0) { jobs = _this._uploadJobs; }
                    return jobs.filter(function (job) { return job.chunk.id !== chunkId; });
                }
            }
        };
        this._fileUploads = [];
        this._uploaders = [];
        this._uploadJobs = [];
    }
    return State;
}());
exports.default = State;
//# sourceMappingURL=State.js.map